<template>
  <div :class="[theme.container, containerClass]" v-if="buttons?.length">
    <div v-for="(button, index) in buttons" :key="index">
      <component
        :is="Commons.isInternalLink(button.link) ? 'router-link' : 'a'"
        :to="Commons.isInternalLink(button.link) ? button.link : null"
        :href="!Commons.isInternalLink(button.link) ? button.link : null"
        :class="[buttonClass(button.variant), button.class || '']"
      >
        {{ button.label }}
      </component>
    </div>
  </div>
</template>

<script setup>
import Commons from '@/shared/utils/commons'
import { buttonGroupBlockTheme, buttonClass } from './scripts/themeHelpers'

const props = defineProps({
  buttons: { type: Array, default: () => [] },
  variant: { type: String, default: 'default' },
  containerClass: { type: String, default: '' },
})

const theme = buttonGroupBlockTheme(props.variant)
</script>

<style scoped>
/* Styles additionnels si nécessaire */
</style>
